import React, { useEffect, useState } from "react";

export const EstatusSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  return (
    <select
      className="select-estatus"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="O">Consolidado</option>
      <option value="P">Pendiente</option>
      <option value="R">Revisión</option>
      <option value="C">Cobranza</option>
      <option value="J">Juridico</option>
      <option value="T">Finalizado</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};